var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPaper = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 16,
  viewBox: "0 0 19 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  clipPath: "url(#clip0_2845_1805)"
}, /*#__PURE__*/React.createElement("g", {
  id: "News"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M14.0791 16H3.2791C1.7941 16 0.579102 14.8 0.579102 13.3333V4.44444C0.579102 2.97778 1.7941 1.77778 3.2791 1.77778H4.3321C4.7011 0.746667 5.7091 0 6.8791 0H15.8791C17.3641 0 18.5791 1.2 18.5791 2.66667V11.5556C18.5791 14.0089 16.5631 16 14.0791 16ZM5.8261 14.2222H14.0791C15.5641 14.2222 16.7791 13.0222 16.7791 11.5556V2.66667C16.7791 2.17778 16.3741 1.77778 15.8791 1.77778H6.8791C6.3841 1.77778 5.9791 2.17778 5.9791 2.66667V13.3333C5.9791 13.6444 5.9251 13.9467 5.8261 14.2222ZM3.2791 3.55556C2.7841 3.55556 2.3791 3.95556 2.3791 4.44444V13.3333C2.3791 13.8222 2.7841 14.2222 3.2791 14.2222C3.7741 14.2222 4.1791 13.8222 4.1791 13.3333V3.55556H3.2791Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M14.0793 7.99984H8.6793C8.1843 7.99984 7.7793 7.59984 7.7793 7.11095V3.55539C7.7793 3.0665 8.1843 2.6665 8.6793 2.6665H14.0793C14.5743 2.6665 14.9793 3.0665 14.9793 3.55539V7.11095C14.9793 7.59984 14.5743 7.99984 14.0793 7.99984ZM9.5793 6.22206H13.1793V4.44428H9.5793V6.22206Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M14.0793 10.6664H8.6793C8.1843 10.6664 7.7793 10.2664 7.7793 9.77756C7.7793 9.28867 8.1843 8.88867 8.6793 8.88867H14.0793C14.5743 8.88867 14.9793 9.28867 14.9793 9.77756C14.9793 10.2664 14.5743 10.6664 14.0793 10.6664Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M14.0793 13.333H8.6793C8.1843 13.333 7.7793 12.933 7.7793 12.4441C7.7793 11.9552 8.1843 11.5552 8.6793 11.5552H14.0793C14.5743 11.5552 14.9793 11.9552 14.9793 12.4441C14.9793 12.933 14.5743 13.333 14.0793 13.333Z"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2845_1805"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 16,
  fill: "white",
  transform: "translate(0.579102)"
})))));
export default SvgIconPaper;